import React from 'react';
import styles from './index.module.scss';
import { Loading } from 'components/loading/Loading';

const EditAction = ({ onClick, loading }: { onClick: () => void; loading: boolean }) => {
  return (
    <div className={styles['edit-action']}>
      {!loading ? (
        <i
          onClick={onClick}
          className='fa fa-pencil'
        />
      ): (
        <Loading type={'mini'} />
      )
      }
    </div>
  );
};

export default EditAction;
